module.exports = __webpack_public_path__ + "static/media/cable-clouds-danger-dawn-171428.687a0021.jpg";